export default __webpack_public_path__ + "static/media/2.d10aaa09.webp";